import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Connection between an innovation asset and a project that it was used on',
    name: 'Innovation Asset Project',
    partialId: PartialId.Standard.create('innovation_asset_project'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
